package com.eladfinish.bible.contest.screens.openQuestions.api

import com.eladfinish.bible.contest.network.simplifiedApiResultUTF8
import com.eladfinish.bible.contest.utils.Sheet
import io.ktor.client.HttpClient
import io.ktor.client.request.get
import io.ktor.client.request.parameter
import io.ktor.client.request.url

interface GoogleDriveApi {
    suspend fun getDataFromSpreadsheet(
        sheetId: String,
        sheetNumber: Int,
        format: String,
    ): Result<Sheet?>
}

class GoogleDriveApiImpl(
    private val client: HttpClient,
) : GoogleDriveApi {

    companion object {
        private const val DRIVE_URL = "https://drive.google.com/"
    }

    override suspend fun getDataFromSpreadsheet(
        sheetId: String,
        sheetNumber: Int,
        format: String,
    ): Result<Sheet?> =
        simplifiedApiResultUTF8 {
            client.get {
                url(urlString = "$DRIVE_URL/")
                parameter("sheetId", sheetId)
                parameter("sheetNumber", sheetNumber)
                parameter("format", format)
            }
        }

}
